
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/build",
      function () {
        return require("private-next-pages/build/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/build"])
      });
    }
  